import React, { useEffect } from "react";
import { useTheme } from "../core/action";

const ThemeProvider = ({ children }) => {
  const { getPreferredTheme, setPreferredTheme } = useTheme();

  useEffect(() => {
    setPreferredTheme(getPreferredTheme());
    // eslint-disable-next-line
  }, []);

  return <div>{children}</div>;
};

export default ThemeProvider;
